import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  children: React.ReactNode;
}

function Toolbar({ children }: Props) {
  const classes = useStyles();

  return <div className={classes.root}>{children}</div>;
}

const useStyles = makeStyles(theme => ({
  root: { backgroundColor: theme.palette.grey[100] },
}));

export default Toolbar;
